import React from "react";
import AppButton from "components/ui/AppButton";
import TimesUp from "../components/times-up";
import { useTranslation } from "react-i18next";

const Packages = (props) => {
const { t } = useTranslation();
  const handleContactUs = () => {
    window.open(`https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}?text=How%20can%20we%20help?`, "_blank");
  };

  return (
    <>
   
      <div className="w-full h-full rounded-3xl bg-white p-5 flex flex-col gap-4 justify-center items-center ">
        <div>
        <TimesUp />
        </div>
        <span className="text-red-500 text-24px font-bold text-center">{t("Your subscription has expired")}</span>
        <span className="text-gray-500 text-20px font-semibold text-center">{t("Please contact us to renew your subscription")}</span>
        <div>
        <AppButton
        onClick={handleContactUs}
        >
          <span>
            {t("Contact Us")}
          </span>
        </AppButton>

      </div>
      </div>
    </>
  );
};

export default Packages;
